import React from 'react';
import { CommandItem } from '@/components/ui/command';
import { Check, MapPin } from 'lucide-react';
import { LocationSuggestion } from '@/services/locationService';

interface SuggestionItemProps {
  suggestion: LocationSuggestion;
  isSelected: boolean;
  onSelect: () => void;
}

export const SuggestionItem: React.FC<SuggestionItemProps> = ({
  suggestion,
  isSelected,
  onSelect
}) => {
  return (
    <CommandItem
      key={suggestion.place_id}
      value={suggestion.description}
      onSelect={onSelect}
      className="cursor-pointer"
    >
      <div className="flex flex-col w-full overflow-hidden">
        <div className="flex items-center">
          <MapPin className="h-4 w-4 mr-2 text-muted-foreground" />
          {suggestion.structured_formatting ? (
            <span className="font-medium">{suggestion.structured_formatting.main_text}</span>
          ) : (
            <span className="font-medium">{suggestion.description}</span>
          )}
          {isSelected && (
            <Check className="h-4 w-4 ml-auto" />
          )}
        </div>
        {suggestion.structured_formatting && (
          <span className="text-xs text-muted-foreground ml-6">
            {suggestion.structured_formatting.secondary_text}
          </span>
        )}
      </div>
    </CommandItem>
  );
};